
import router from './router';
import { analytics } from '@/lib/util/FirebaseConfig';
import { kioskSetup } from '@/lib/KioskSetup';
import { version } from './version';
import RootVue from './RootVue';

console.log(`kiosk-app version=${version} kioskId=${kioskSetup.kioskId}`);
analytics.logEvent("start_kiosk", { kioskId: kioskSetup.kioskId });
new RootVue({router}).$mount('#app');
